import axios from "axios";
import { clientVitalsAPI } from "../secrets";

export const addNewCustomer = async (name: string, email: string, phone: string) => {
  try {
    if (!name || !email || !phone) return;

    const result: Record<any, any> = await axios.post(`${clientVitalsAPI}/stripe/customers/add`, {
      name, email, phone
    });

    return result?.data?.customer;
  } catch (error) {
    throw error;
  }
};